import { useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import publicAxios from "../../utils/publicAxios";
import { userReferralPromoSignupUrl } from "../../utils/constants/apiEndPoints";
import { NOT_FOUND, SIGNUP_WITH_PROMO_PARAMS } from "../../route/paths";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

const PromoCodeRedirect = () => {
  const { userId, promoCodeId, historyId } = useParams();
  const navigate = useNavigate();

  const getPromoCode = useCallback(async () => {
    if (userId && promoCodeId && historyId) {
      try {
        const response = await publicAxios.post(
          userReferralPromoSignupUrl,
          {},
          {
            params: {
              userAccountId: userId,
              originalPromoCodeId: promoCodeId,
              referralPromoEmailHistoryId: historyId
            }
          }
        );

        const { promoCode, referralUsageHistoryId } =
          response?.data?.data || {};
        if (promoCode && referralUsageHistoryId) {
          navigate(SIGNUP_WITH_PROMO_PARAMS(promoCode, referralUsageHistoryId));
        } else {
          navigate(NOT_FOUND);
        }
      } catch (error) {
        showToast(error.response.data.message, showToastType.error);
      }
    }
  }, [userId, promoCodeId, historyId, navigate]);

  useEffect(() => {
    getPromoCode();
  }, [getPromoCode]);

  return null;
};

export default PromoCodeRedirect;
